import React from 'react';
import SEO from '../components/SEO';

const Terms: React.FC = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Terms and Conditions",
    "description": "Terms and conditions for using ReelVindicator.com"
  };

  return (
    <>
      <SEO
        title="Terms and Conditions - ReelVindicator"
        description="Read our terms and conditions for using ReelVindicator.com. Understand your rights and responsibilities when using our casino review platform."
        schema={schema}
      />

      <div className="pt-20 pb-12">
        <section className="py-12 bg-gradient-to-br from-dark-surface to-dark-bg">
          <div className="container mx-auto px-4">
            <h1 className="text-5xl md:text-6xl font-bold text-center mb-4">
              <span className="text-gradient">Terms and Conditions</span>
            </h1>
            <p className="text-gray-400 text-center">Last updated: {new Date().toLocaleDateString()}</p>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4 max-w-4xl">
            <div className="glass p-8 rounded-xl space-y-8">
              <div>
                <h2 className="text-3xl font-bold mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-400 leading-relaxed">
                  By accessing and using ReelVindicator.com, you accept and agree to be bound by the terms and provision of this agreement. 
                  If you do not agree to abide by the above, please do not use this service.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">2. Use License</h2>
                <p className="text-gray-400 leading-relaxed mb-4">
                  Permission is granted to temporarily access the materials on ReelVindicator.com for personal, non-commercial transitory viewing only. 
                  This is the grant of a license, not a transfer of title, and under this license you may not:
                </p>
                <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4">
                  <li>Modify or copy the materials</li>
                  <li>Use the materials for any commercial purpose or for any public display</li>
                  <li>Attempt to reverse engineer any software contained on the website</li>
                  <li>Remove any copyright or other proprietary notations from the materials</li>
                </ul>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">3. Disclaimer</h2>
                <p className="text-gray-400 leading-relaxed">
                  The materials on ReelVindicator.com are provided on an 'as is' basis. ReelVindicator makes no warranties, expressed or implied, 
                  and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, 
                  fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">4. Limitations</h2>
                <p className="text-gray-400 leading-relaxed">
                  In no event shall ReelVindicator or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, 
                  or due to business interruption) arising out of the use or inability to use the materials on ReelVindicator.com, even if ReelVindicator 
                  or a ReelVindicator authorized representative has been notified orally or in writing of the possibility of such damage.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">5. Accuracy of Materials</h2>
                <p className="text-gray-400 leading-relaxed">
                  The materials appearing on ReelVindicator.com could include technical, typographical, or photographic errors. 
                  ReelVindicator does not warrant that any of the materials on its website are accurate, complete, or current. 
                  ReelVindicator may make changes to the materials contained on its website at any time without notice.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">6. Links</h2>
                <p className="text-gray-400 leading-relaxed">
                  ReelVindicator has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. 
                  The inclusion of any link does not imply endorsement by ReelVindicator of the site. Use of any such linked website is at the user's own risk.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">7. Modifications</h2>
                <p className="text-gray-400 leading-relaxed">
                  ReelVindicator may revise these terms of service for its website at any time without notice. 
                  By using this website you are agreeing to be bound by the then current version of these terms of service.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">8. Governing Law</h2>
                <p className="text-gray-400 leading-relaxed">
                  These terms and conditions are governed by and construed in accordance with the laws of the United Kingdom and you irrevocably submit 
                  to the exclusive jurisdiction of the courts in that location.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">9. Responsible Gambling</h2>
                <p className="text-gray-400 leading-relaxed">
                  ReelVindicator promotes responsible gambling. If you feel you may have a gambling problem, please seek help from organizations 
                  such as GambleAware, GamCare, or BeGambleAware. Gambling should be fun, not a way to make money or escape problems.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">10. Age Restriction</h2>
                <p className="text-gray-400 leading-relaxed">
                  You must be 18 years or older to use this website. By using ReelVindicator.com, you confirm that you are of legal age 
                  to gamble in your jurisdiction.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Terms;

